function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.45455 1.5C4.09894 1.5 3 2.59894 3 3.95455V17.0455C3 18.4011 4.09894 19.5 5.45455 19.5H15.2727C16.6284 19.5 17.7273 18.4011 17.7273 17.0455V7.90508C17.7273 7.25409 17.4686 6.62977 17.0083 6.16945L13.0578 2.21892C12.5975 1.7586 11.9732 1.5 11.3222 1.5H5.45455ZM4.63636 3.95455C4.63636 3.50268 5.00268 3.13636 5.45455 3.13636H10.3636V7.22727C10.3636 8.13101 11.0962 8.86364 12 8.86364H16.0909V17.0455C16.0909 17.4973 15.7246 17.8636 15.2727 17.8636H5.45455C5.00268 17.8636 4.63636 17.4973 4.63636 17.0455V3.95455ZM15.752 7.22727L12 3.47526V7.22727H15.752Z",
  fill: "#5575FA"
});

var SvgBriefIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBriefIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/brief-icon.4bdb499f.svg";
export { ForwardRef as ReactComponent };